//function to Parse the response
import { AxiosHeaders } from "axios";
import parse from "html-react-parser"; // To render HTML responses

export const cleanHTML = (text) => {
  if (!text) return "No response available.";
  const cleanedText = text.replace(/<\/?html>|<\/?head.*?>|<\/?body.*?>/g, "").trim();
  return parse(text.replace(/```html|```/g, "").trim());
};

export const getUserLocalData = () => {
  const token = JSON.parse(localStorage.getItem("access_token"));
  const code = localStorage.getItem("code");
  const verifier = localStorage.getItem("verifier");
  const patient_id = localStorage.getItem("patient_id");
  const patient_name = localStorage.getItem("patient_name");
  const session_id = localStorage.getItem("session_id");
  const user_name = localStorage.getItem("user_name");
  const preferred_username = localStorage.getItem("preferred_username")
  const validPatientId =
    patient_id && patient_id !== "undefined" ? patient_id : null
  return { token,code, verifier ,patient_id, session_id, patient_name, validPatientId, user_name, preferred_username };
}

export const getCustomPrompts = {
  patientStatus: 'provide a full diagnostic on patient and provide next steps with recommended actions',
  admissionStatus: 'Is this patient okay for discharge?',
  documentation: 'Provide the progress note and discharge summary of this patient',
}

export const getTimeAgo = (timestamp) => {
  const now = new Date();
  const diffInSeconds = Math.floor((now - new Date(timestamp)) / 1000);

  if (diffInSeconds < 60) return `${diffInSeconds} sec ago`;
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours} hr ago`;
  const diffInDays = Math.floor(diffInHours / 24);
  return `${diffInDays} days ago`;
};

export const removeExistingSessionData = () => {
  localStorage.removeItem("patient_id");
  localStorage.removeItem("session_id");
  localStorage.removeItem("patient_name");
}

export const saveRecentChatPatientData = (data) => {
  localStorage.setItem("patient_id",data?.patient_id);
  localStorage.setItem("patient_name",data?.patient_name);
  localStorage.setItem("session_id",data?.conversation_id);
}

export const getHeaders = () => {
  const token = getUserLocalData().token;
  const headers = new AxiosHeaders();

  headers.set('Authorization', `Bearer ${token}`);
  headers.set('Content-Type', 'application/json');
  headers.set('Accept', 'application/json');
  return headers;
};

export const getNameInitials = (name) => {
 return name.match(/(\b\S)?/g).join("").toUpperCase()
}
